import { PagesBanner, Team } from "../components";

import Ard from "../assets/team/ardbraha.jpg";
import Ensar from "../assets/team/ensar.PNG";
import Fatbardha from "../assets/team/fatbardha.jpeg";
import Pellumb from "../assets/team/pellumb.JPG";
import Qendresa from "../assets/team/qendresa.PNG";
import Lorik from "../assets/team/lorikrama.JPG";
import Valbona from "../assets/team/valbona.JPG";
import Agron from "../assets/team/agron.png";
import Hamide from "../assets/team/hamide.jpg";
import Njomza from "../assets/team/njomza.png";
import SuelaH from "../assets/team/suelah.jpeg";
import Erxhan from "../assets/team/erxhan.jpg";
import Ambera from "../assets/team/ambera.png";
import ExecutiveDirector from "../assets/team/ExecutiveDirector.jpg";
import SuelaAl from "../assets/team/suela.jpg";
import Genci from "../assets/team/genci.jpg";
import Shpresa from "../assets/team/shpresa.png";
import Fatlum from "../assets/team/fatlum.png";
import Rinesa from "../assets/team/rinesa.png";
import FatjonaS from "../assets/team/fatjonas.png";
import FatjonaK from "../assets/team/fatjona.png";
import Enesa from "../assets/team/enesa.png";
import Kushtrimi from "../assets/team/kushtrimi.png";
import Sanije from "../assets/team/sanije.png";
import Merita from "../assets/team/merita.png";

const data = [
  {
    pfp: Ensar,
    name: "Ensar Bajrami",
    position: "Founder and CEO",
    linkedin: "https://www.linkedin.com/in/ensar-bajrami-a10a918a/",
  },
  {
    pfp: Fatbardha,
    name: "Fatbardha Dallku",
    position: "Co-Founder and Deputy CEO",
    linkedin: "https://www.linkedin.com/in/fatbardha-dallku-2584a734/",
  },
  {
    pfp: Genci,
    name: "Genc Shurdho",
    position: "Ceo & Director of project Albania",
    linkedin: "#",
  },
  {
    pfp: ExecutiveDirector,
    name: "Valbona Karkini Mustafa",
    position: "Executive Director in Kavaja, Albania",
    linkedin: "#",
  },
  {
    pfp: Merita,
    name: "Merita Hysaj Isaraj",
    position: "Executive Director in Gjirokastra, Albania",
    linkedin: "#",
  },
  {
    pfp: SuelaAl,
    name: "Suela Ceka",
    position: "Managing Director in Albania",
    linkedin: "#",
  },
  {
    pfp: Qendresa,
    name: "Qëndresa Beqiri",
    position: "Head of Programming Department",
    linkedin: "#",
  },
  {
    pfp: Pellumb,
    name: "Pëllumb Sadiku",
    position: "Programming Teacher / CTO",
    linkedin: "https://www.linkedin.com/in/pellumbsadiku/",
  },
  {
    pfp: Agron,
    name: "Agron Ahmeti",
    position: "Programming Teacher",
    linkedin: "#",
  },
  {
    pfp: Ard,
    name: "Ard Braha",
    position: "Programming Teacher",
    linkedin: "https://www.linkedin.com/in/ardbraha/",
    isArdi: true,
  },
  {
    pfp: Lorik,
    name: "Lorik Rama",
    position: "Programming Teacher",
    linkedin: "https://www.linkedin.com/in/lorikramaa/",
  },
  {
    pfp: Kushtrimi,
    name: "Kushtrim Hajrizi",
    position: "Programming Teacher",
    linkedin: "#",
  },
  {
    pfp: Valbona,
    name: "Valbona Krasniqi",
    position: "Administrative Assistant",
    linkedin: "",
  },
  {
    pfp: Ambera,
    name: "Ambera Peci",
    position: "Administrative Assistant",
    linkedin: "",
  },
  {
    pfp: Erxhan,
    name: "Erxhan Llapashtica",
    position: "Designer",
    linkedin: "#",
  },
  {
    pfp: SuelaH,
    name: "Suela Hasani",
    position: "Social Media Manager",
    linkedin: "https://www.linkedin.com/in/suela-hasani-1258481b4/",
  },
  {
    pfp: Njomza,
    name: "Njomza Badivuku",
    position: "Head of English Department",
    linkedin: "https://www.linkedin.com/in/njomza-badivuku-970260326/",
  },
  {
    pfp: Hamide,
    name: "Hamide Januzi",
    position: "English Teacher",
    linkedin: "https://www.linkedin.com/in/hamide-januzi-453bba1a8/",
  },
  {
    pfp: Shpresa,
    name: "Shpresa Ujkani Bince",
    position: "English Teacher",
    linkedin: "#",
  },
  {
    pfp: Fatlum,
    name: "Fatlum Osmani",
    position: "English Teacher",
    linkedin: "#",
  },
  {
    pfp: FatjonaK,
    name: "Fatjona Sadiku",
    position: "English Teacher",
    linkedin: "#",
  },
  {
    pfp: Sanije,
    name: "Sanije Selimi",
    position: "Extra Lessons",
    linkedin: "#",
  },
  {
    pfp: FatjonaS,
    name: "Fatjona Kajtazi",
    position: "Extra Lessons",
    linkedin: "#",
  },
  {
    pfp: Rinesa,
    name: "Rinesa Salihu",
    position: "Extra Lessons",
    linkedin: "#",
  },
  {
    pfp: Enesa,
    name: "Enesa Sejdiu",
    position: "Social Media Manager",
    linkedin: "",
  },
];

export default function TeamPage() {
  return (
    <>
      <PagesBanner
        title="Team"
        description="Alone we can do so little, together we can do so much."
      />
      <Team data={data} />
    </>
  );
}
